import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import FinancialInstitutionImagePicker
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/FinancialInstitutionImagePicker';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import RemainingFieldList from 'Components/UI/Meta/MetaForm/Components/MetaLayout/RemainingFieldList';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import ProgressCard from './ProgressCard';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  progressCard: {
    marginBottom: theme.spacing(4),
  },
  blueSubtitle: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    color: theme.palette.facet.accentBlue19,
  },
  balance: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.accentBlue19,
    marginBottom: theme.spacing(2),
  },
  form: {
    margin: 'auto',
    marginBottom: theme.spacing(1),
    width: theme.dimensions.md,
    padding: theme.spacing(2),
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  deleteButton: {
    margin: 'auto',
    backgroundColor: theme.palette.facet.accentRed3,
  },
  deleteIcon: {
    color: theme.palette.facet.red,
  },
  buttonWrapper: {
    marginBottom: theme.spacing(1),
  },
});

const Layout = ({
  className,
  classes,
  index,
  total,
}) => {
  const { resource, metaOverrideSet } = useMetaLayoutContext();
  const { modalCollection } = useModalContext();
  const [thisStep] = modalCollection;
  const [isLiability, setIsLiability] = useState(false);

  useEffect(() => {
    const accountType = resource.attr('virtualAccountType');
    switch (accountType) {
      case 'cash':
      case 'education_account':
      case 'non_retirement_account':
      case 'employer_sponsored_plan':
      case 'employee_stock_options':
      case 'bank_account':
      case 'personal_retirement_account':
      case 'health_savings_account':
        setIsLiability(false);
        break;
      case 'liability':
        setIsLiability(true);
        break;
      default:
        break;
    }
  }, [resource.attr('virtualAccountType')]);


  return (
    <div
      className={classNames(className, classes.root)}
      test={'virtual-account-setup-stepper'}
    >
      <ProgressCard
        className={classes.progressCard}
        stepResource={thisStep}
      />
      {resource.meta().field('virtualAccountName').attr('required') === true ? (
        <MetaControlField attr={'virtualAccountName'} />
      ) : (
        <Subtitle text={resource.attr('virtualAccountName')} align={'center'} />
      )}

      <FinancialInstitutionImagePicker
        resource={resource}
        width={'100'}
        height={'auto'}
      />
      <MetaControlField attr={'virtualAccountType'} />
      <MetaControlField attr={'virtualAccountSubType'} />
      <MetaControlField attr={'balanceForThisOutcome'} />
      {isLiability && <MetaControlField attr={'virtualAccountInterestRate'} />}
      {!isLiability && <MetaControlField attr={'allocationType'} />}
      {isLiability && <MetaControlField attr={'minimumMonthlyPayment'} />}
      <MetaControlField attr={'ownerTypeId'} />
      <RemainingFieldList
        fullWidth
        metaOverrideSet={metaOverrideSet}
        MetaControlFieldProps={{
          hideViaMetaOverride: true,
        }}
      />
      <Typography
        className={classes.blueSubtitle}
        variant={'h6'}
        color={'primary'}
      >
        {`${index} of ${total}`}
      </Typography>
    </div>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  /** index: The index of the current resource in the collection. One based numbering (arrayIndex+1). Provied by withCollectionStepper HOC * */
  index: PropTypes.number.isRequired,
  /** total: The total resources in the collection. Provied by withCollectionStepper HOC * */
  total: PropTypes.number.isRequired,
};

export default withStyles(styles)(Layout);
